import _asyncToGenerator from "D:/Coding/help-doc/help-doc-front/help-doc-frontend/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/Coding/help-doc/help-doc-front/help-doc-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
// 导入组件
import { defineComponent } from "vue";
import { ElMessageBox } from 'element-plus';
import GHSubCategory from "@/components/GHSubCategory";
import { get_category_components, get_enabled_component, get_setting } from "@/service/api";
import { mapActions, mapState } from 'vuex';
export default defineComponent({
  name: "GrasshopperTabs",
  components: {
    GHSubCategory: GHSubCategory
  },
  props: {
    categories: [Object]
  },
  setup: function setup() {
    var search_list = null;
    return {
      search_list: search_list
    };
  },
  data: function data() {
    return {
      isSubLoading: true,
      isCompLoading: false,
      currentTabName: "",
      allCategories: {},
      currentCategory: {},
      allComponents: {},
      currentComponent: {},
      topText: "",
      topTip: {},
      diyTop: "",
      diyBottom: "",
      drawer: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    rows_count: function rows_count(state) {
      return state.component_rows;
    }
  })), {}, {
    thisAppPath: function thisAppPath() {
      return this.$route.path.split('/').slice(0, 2).join('/');
    }
  }),
  watch: {
    categories: function categories(newValue) {
      var _this = this;

      newValue.forEach(function (item) {
        _this.allCategories[item.name] = {
          "id": item.id,
          "name": item.name,
          "subCategories": []
        };
      });
      this.initCurrentCategory();
      this.initCurrentComponent();
    },
    // 监听路由
    '$route': {
      handler: function handler(to) {
        // 如果 categories 还没有初始化，交给 initCurrentCategory 函数处理，这里不做处理。
        if (this.categories[0] === undefined) {
          return;
        }

        if (to.params.categoryName === undefined) {
          var categoryName = this.categories[0].name;
          this.setCurrentCategory(categoryName);
        } // 路由中有分类名称参数，设置当前分类


        this.setCurrentCategory(to.params.categoryName);

        if (to.params.id === undefined) {
          return;
        }

        this.isCompLoading = true;
        this.setCurrentComponent(to.params.id);
      },
      immediate: true
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;

    get_setting('GhTopText').then(function (result) {
      _this2.topText = result.data.text;
    });
    get_setting('GhTopTip').then(function (result) {
      result.data.key_value.forEach(function (item) {
        if (item.key === 'title') _this2.topTip['title'] = item.value;
        if (item.key === 'content') _this2.topTip['content'] = item.value;
      });
    });
    get_setting('diy_top').then(function (result) {
      _this2.diyTop = result.data.html;
    });
    get_setting('diy_bottom').then(function (result) {
      _this2.diyBottom = result.data.html;
    });
  },
  mounted: function mounted() {},
  provide: function provide() {
    var _this3 = this;

    return {
      staticValue: this.staticValue,
      // 直接返回值，不可响应
      staticObject: this.staticObject,
      // 返回一个对象，可响应
      getReactiveValue: function getReactiveValue() {
        return _this3.staticValue;
      } // 返回一个对象的函数，可响应

    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    get_local_rows: "get_local_rows",
    set_local_rows: "set_local_rows"
  })), {}, {
    handleClickTab: function handleClickTab(tab) {
      // 获取当前的 path
      var appPath = this.$route.path.split('/').slice(0, 2).join('/'); // 点击标签页的时候，这里只跳转路由，在路由 watch 中设置对应模型的切换

      this.$router.push({
        path: "".concat(appPath, "/").concat(tab.props.label, "/")
      });
    },
    handleClickCategoryName: function handleClickCategoryName(name) {
      var appPath = this.$route.path.split('/').slice(0, 2).join('/');
      this.$router.push({
        path: "".concat(appPath, "/").concat(name, "/")
      });
    },
    watchvideo: function watchvideo() {
      var _this4 = this;

      ElMessageBox.alert('请确保您已经购买了这套教学才能观看本视频，如果没有购买，请点击下拉菜单中的体验按钮。', '观看提醒：', {
        confirmButtonText: '我知道了',
        confirmButtonClass: 'btnconfirm',
        lockScroll: false,
        callback: function callback(action) {
          _this4.$message({
            type: 'info',
            message: "action: ".concat(action)
          });
        }
      });
    },
    fontweight: function fontweight(column) {
      if (column.columnIndex === 0) {
        return "font-weight:bold;font-size:14px;";
      }
    },
    setCurrentCategory: function setCurrentCategory(categoryName) {
      var _this5 = this;

      this.currentCategory = this.allCategories[categoryName];
      this.currentTabName = categoryName;

      if (this.currentCategory !== undefined && this.currentCategory.subCategories.length === 0) {
        get_category_components(this.currentCategory.id).then(function (result) {
          if (result.data.length === 0) return;
          _this5.allCategories[categoryName].subCategories = result.data;

          _this5.setCurrentCategory(categoryName);
        });
      }
    },
    initCurrentCategory: function initCurrentCategory() {
      if (this.$route.params.categoryName === undefined) {
        var categoryName = this.categories[0].name;
        this.setCurrentCategory(categoryName);
        return;
      }

      this.setCurrentCategory(this.$route.params.categoryName);
    },
    initCurrentComponent: function initCurrentComponent() {
      if (this.$route.params.id === undefined) {
        return;
      }

      this.isCompLoading = true;
      this.setCurrentComponent(this.$route.params.id);
    },
    setCurrentComponent: function setCurrentComponent(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this6.allComponents[id] !== undefined)) {
                  _context.next = 4;
                  break;
                }

                _this6.currentComponent = _this6.allComponents[id];
                _context.next = 6;
                break;

              case 4:
                _context.next = 6;
                return get_enabled_component(id).then(function (result) {
                  _this6.currentComponent = result;
                  _this6.allComponents[id] = result;
                });

              case 6:
                _this6.isCompLoading = false;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    updateCurrentComponent: function updateCurrentComponent(id) {
      var appPath = this.$route.path.split('/').slice(0, 2).join('/');
      this.$router.push({
        path: "".concat(appPath, "/").concat(this.currentCategory.name, "/").concat(id)
      });
    }
  })
});